import React from 'react';
import PropTypes from 'prop-types';
import PDFPageEditorOptInPanelCanvas from 'PDFPageCanvas';
import PDFPageEditorOptInPanelEnum from './PDFPageEditorOptInPanelConstants';

export default class PDFPageEditorOptInPanelWrapper extends React.Component {
  constructor() {
    super();

    this.redirectToFreeWrite = this.redirectToFreeWrite.bind(this);
    this.redirectToRearrangePDFPages = this.redirectToRearrangePDFPages.bind(this);
  }

  componentDidMount() {
    this.props.setPagesFromFile(
      this.props.pdfFile,
      PDFPageEditorOptInPanelEnum.PDF_PAGE_EDITOR_OPT_IN_PANEL_SET_PAGES_FROM_FILE,
    );
  }

  redirectToFreeWrite() {
    window._track('V2 | Edit PDF', 'Edit Pages');
    window.location.assign(`/free-write/edit.php?documentType=${this.props.documentKey}`);
  }

  redirectToRearrangePDFPages() {
    window._track('V2 | Edit Pages', 'Edit Pages');
    window.location.assign(`/free-write/edit-pages.php?initial_pdf_link=${this.props.pdfFile}`);
  }

  render() {
    const pageLabel = (this.props.pages.length > 1) ? 'pages' : 'page';
    return (
      <div className="pdf-page-editor-opt-in-pannel-wrapper">
        {this.props.pages.length > 0 &&
          <React.Fragment>
            <PDFPageEditorOptInPanelCanvas
              width={139}
              height={179}
              page={this.props.pages[0].page}
            />
            <span
              className="pdf-page-editor-opt-in-pannel-page-count"
            >
              {this.props.pages.length} {pageLabel} uploaded
            </span>
            <h3
              className="pdf-page-editor-opt-in-pannel-cta-header"
            >
              Do you need to add, remove, or reorder pages in your PDF?
            </h3>
            <div className="pdf-page-editor-opt-in-pannel-cta-buttons-wrapper">
              <button
                className="pdf-page-editor-opt-in-pannel-cta-button go-to-free-write btn"
                onClick={this.redirectToFreeWrite}
              >
                No, Go to Editor
              </button>
              <button
                className="pdf-page-editor-opt-in-pannel-cta-button go-to-rearrange"
                onClick={this.redirectToRearrangePDFPages}
              >
                Yes, Organize Pages
              </button>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
}
PDFPageEditorOptInPanelWrapper.propTypes = {
  pdfFile: PropTypes.string.isRequired,
  documentKey: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape()),
  setPagesFromFile: PropTypes.func.isRequired,
};

PDFPageEditorOptInPanelWrapper.defaultProps = {
  pages: [],
};



// WEBPACK FOOTER //
// ./src-react/PDFPageEditorOptInPanel/PDFPageEditorOptInPanelWrapper.jsx